/**
 * Read more
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        $('.read-more .toggle-icon').on('click', function () {
            $(this).parents('.read-more').toggleClass('opened');
        });

        $('.read-more .toggle-element').on('click', function () {
            const $ptr = $(this).parents('.read-more');
            $('.read-more[data-autoclose]').not($ptr).removeClass('opened');
            $ptr.toggleClass('opened');
        });
    }
});
